export interface LocalizedString {
  en: string;
  zh: string;
}

export interface TravelStop {
  id: string;
  city: LocalizedString;
  country: LocalizedString;
  lat: number;
  lng: number;
  year: number;
}

export type TravelRoute = readonly [fromId: string, toId: string];

export const travelStops: TravelStop[] = [
  {
    id: 'hangzhou',
    city: { en: 'Hangzhou', zh: '杭州' },
    country: { en: 'China', zh: '中国' },
    lat: 30.2741,
    lng: 120.1551,
    year: 2023,
  },
  {
    id: 'tokyo',
    city: { en: 'Tokyo', zh: '东京' },
    country: { en: 'Japan', zh: '日本' },
    lat: 35.6762,
    lng: 139.6503,
    year: 2024,
  },
  {
    id: 'reykjavik',
    city: { en: 'Reykjavik', zh: '雷克雅未克' },
    country: { en: 'Iceland', zh: '冰岛' },
    lat: 64.1466,
    lng: -21.9426,
    year: 2025,
  },
  {
    id: 'paris',
    city: { en: 'Paris', zh: '巴黎' },
    country: { en: 'France', zh: '法国' },
    lat: 48.8566,
    lng: 2.3522,
    year: 2025,
  },
];

export const travelRoutes: TravelRoute[] = [
  ['hangzhou', 'tokyo'],
  ['tokyo', 'reykjavik'],
  ['reykjavik', 'paris'],
];
